import { Injectable } from '@angular/core';
import { OnlineExamSchedule } from '../../dashboard/models/online-exam-schedule';
import { Observable } from 'rxjs';
import { AppSettings } from 'src/app/utils/app-settings';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Template } from 'src/app/models/template';

@Injectable({
  providedIn: 'root'
})
export class ExamTestService {

  constructor(private http: HttpClient) { }

  getUpcomingOnlineExamTests(): Observable<OnlineExamSchedule[]>{
    return this.http.get<OnlineExamSchedule[]>(AppSettings.apiUrl + "examTest?type=Upcoming&mode=Online");
  }

  getExamTestById(testId: number): Observable<HttpResponse<OnlineExamSchedule>> {
    return this.http.get<OnlineExamSchedule>(AppSettings.apiUrl + "examTest/" + testId, {observe: 'response'});
  }

  getExamLobbyInfo(testId: number): Observable<Template> {
    return this.http.get<Template>(`${AppSettings.apiUrl}examTest/${testId}/examInfo`);
  }
}
